export default function Gallery() {
  const projects = [
    {
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_20241227_155810-1920w.jpg',
      title: 'Modern Kitchen',
      category: 'Residential'
    },
    {
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_6535-1920w.jpg',
      title: 'Commercial Reception',
      category: 'Commercial'
    },
    {
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_1089-1920w.jpg',
      title: 'Bathroom Vanity',
      category: 'Residential'
    },
    {
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_3578-1920w.jpg',
      title: 'Custom Bar',
      category: 'Residential'
    },
    {
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_20241227_155817-1920w.jpg',
      title: 'Office Breakroom',
      category: 'Commercial'
    },
    {
      image: 'https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/IMG_20241028_114328-1920w.jpg',
      title: 'Luxury Kitchen Island',
      category: 'Residential'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Recent <span className="text-amber-600">Projects</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our portfolio of stunning countertop installations
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 aspect-square"
            >
              <img 
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block bg-amber-600 text-white text-xs font-semibold px-3 py-1 rounded-full mb-2">
                    {project.category}
                  </span>
                  <h3 className="text-xl font-bold text-white">
                    {project.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Brands Section */}
        <div className="mt-20">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-10">
            Trusted Material Partners
          </h3>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-8 items-center opacity-60 hover:opacity-100 transition-opacity">
            <img src="https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/Untitled+design+-+2026-01-08T171010.045-1920w.png" alt="Cambria" className="w-full h-16 object-contain grayscale hover:grayscale-0 transition-all" />
            <img src="https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/a-one-solid-surfacing-logo-della-terra-1920w.webp" alt="Della Terra" className="w-full h-16 object-contain grayscale hover:grayscale-0 transition-all" />
            <img src="https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/a-one-solid-surfacing-logo-neolith-1920w.webp" alt="Neolith" className="w-full h-16 object-contain grayscale hover:grayscale-0 transition-all" />
            <img src="https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/logo-dekton-1920w.jpg" alt="Dekton" className="w-full h-16 object-contain grayscale hover:grayscale-0 transition-all" />
            <img src="https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/a-one-solid-surfacing-logo-livingstone-1920w.webp" alt="LivingStone" className="w-full h-16 object-contain grayscale hover:grayscale-0 transition-all" />
            <img src="https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/a-one-solid-surfacing-logo-cambria-premier-partner-1920w.webp" alt="Cambria Premier Partner" className="w-full h-16 object-contain grayscale hover:grayscale-0 transition-all" />
          </div>
        </div>
      </div>
    </section>
  );
}